import { render, staticRenderFns } from "./customer-details.vue?vue&type=template&id=6a794a21&scoped=true&"
import script from "./customer-details.vue?vue&type=script&lang=js&"
export * from "./customer-details.vue?vue&type=script&lang=js&"
import style0 from "./customer-details.vue?vue&type=style&index=0&id=6a794a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a794a21",
  null
  
)

export default component.exports